// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"1173e20f","453":"e2935b42","493":"2b304922","648":"da752faf","878":"8a750177"}[chunkId] + ".chunk.js";
};